import React from "react";
import { DiagramPageData } from "../types";
import { InfoCard } from "./InfoCard";

type FloorAndStrapsProps = {
  pageData: DiagramPageData;
};

export const FloorAndStraps = ({ pageData }: FloorAndStrapsProps) => {
  const [dimensionsFloor, strapsTensioners] = pageData.sections ?? [];

  if (!dimensionsFloor || !strapsTensioners) {
    return null;
  }

  return (
    <>
      <InfoCard
        titleKey={dimensionsFloor.titleKey}
        fields={dimensionsFloor.fields}
        columnFlow
        fullWidth
        autoHeight
      />
      <InfoCard
        titleKey={strapsTensioners.titleKey}
        fields={strapsTensioners.fields}
        singleColumn
        fullWidth
        autoHeight
      />
    </>
  );
};
